/*global tinymce, jQuery */

;(function (tinymce, $) {
  'use strict';

  var A51NonEditable = function (ed, options) {
    this.editor = ed;

    var selectors = this.editor.getParam('a51noneditable_selectors', '.a51noneditable');

    this.nonEditableSelectors = $.isArray(selectors) ? selectors.join(', ') : selectors;

    this.bindEvents();
  };

  A51NonEditable.prototype = {

    constructor : A51NonEditable,

    bindEvents: function () {
      this.editor.on('keydown', $.proxy(this.onKeyDown, this), true);
      this.editor.on('keyup', $.proxy(this.selectNonEditable, this), true);
      this.editor.on('click', $.proxy(this.selectNonEditable, this), true);
      this.editor.on('mousedown', $.proxy(this.selectNonEditable, this), true);
      this.editor.on('mouseup', $.proxy(this.selectNonEditable, this), true);
      this.editor.on('focus', $.proxy(this.selectNonEditable, this), true);
    },

    onKeyDown: function(e) {
      switch (e.which || e.keyCode) {
        //BACKSPACE
        case 8:
          this.removeNonEditable(e);
          break;
        default:
          this.selectNonEditable();
          break;
      }
    },

    removeNonEditable: function (e) {
      var node = this.editor.selection.getNode();

      if ($(node).is(this.nonEditableSelectors)) {
        var removedElement = this.editor.dom.remove(node);
        if (removedElement) {
          e.preventDefault();
        }
      }
    },

    selectNonEditable: function () {
      var node = this.editor.selection.getNode();

      if ($(node).is(this.nonEditableSelectors)) {
        this.editor.selection.select(node);
      }
    }
  };

  tinymce.PluginManager.add('a51noneditable', function(ed, url) {
    new A51NonEditable(ed);
  });
})(tinymce, jQuery);
